import { beautyProfilerAllureRepository } from "../../repository/BeautyProfilerAllureRepository";
import { beautyProfilerProductRepository } from "../../repository/ProductRepository";
import { ProfilerAnswers } from "../../stores/useProfilerStore";
import { BeautyProfilerResults, ScoreMaps } from "../../types/BeautyProfilerResults";
import { computeScores } from "../scoreComputation";
import {
  getMainAllureId,
  getMainFeticheFragranceId,
  getSecondaryFeticheFragranceId,
  getTopLoubiworldFragranceId,
  getTopGlamlinerId,
  getTopOtherProductIds,
} from "../productSelection";
import { findAllureById, findProductById } from "../productUtils";

export const computeBeautyProfilerResults = (
  profiler: string | null,
  answers: ProfilerAnswers,
  isReady: boolean
): BeautyProfilerResults | null => {
  if (!isValidProfilerRequest(profiler, isReady, answers)) {
    return null;
  }

  try {
    const scores = computeScores(answers);
    const results = computeResults(scores);
    
    if (!results) {
      console.error("Failed to compute beauty profiler results - missing required data");
      return null;
    }

    logResults(results);
    return results;
  } catch (error) {
    console.error("Error computing beauty profiler results:", error);
    return null;
  }
};

const isValidProfilerRequest = (
  profiler: string | null,
  isReady: boolean,
  answers: ProfilerAnswers
): boolean => {
  return profiler === "beauty-profiler" && isReady && answers.size > 0;
};

const computeResults = (scores: ScoreMaps): BeautyProfilerResults | null => {
  const { allureScores, productScores } = scores;

  const allure = findAllureById(
    beautyProfilerAllureRepository.getAllAllures(),
    getMainAllureId(allureScores)
  );

  const mainFeticheFragranceId = getMainFeticheFragranceId(productScores);
  const mainFeticheFragrance = findProductById(
    beautyProfilerProductRepository.getAllProducts(),
    mainFeticheFragranceId
  );

  const secondaryFeticheFragrance = findProductById(
    beautyProfilerProductRepository.getAllProducts(),
    getSecondaryFeticheFragranceId(mainFeticheFragranceId, productScores)
  );

  const topLoubiworldFragrance = findProductById(
    beautyProfilerProductRepository.getAllProducts(),
    getTopLoubiworldFragranceId(productScores)
  );

  const topGlamliner = findProductById(
    beautyProfilerProductRepository.getAllProducts(),
    getTopGlamlinerId(productScores)
  );

  const topOtherProductIds = getTopOtherProductIds(productScores, 2);
  const topOtherProducts = beautyProfilerProductRepository
    .getAllProducts()
    .filter((product) => topOtherProductIds.includes(product.id));

  if (!allure || !mainFeticheFragrance || !secondaryFeticheFragrance || 
      !topLoubiworldFragrance || !topGlamliner) {
    return null;
  }

  return {
    allure,
    mainFeticheFragrance,
    secondaryFeticheFragrance,
    topLoubiworldFragrance,
    topGlamliner,
    topOtherProducts,
  };
};

const logResults = (results: BeautyProfilerResults): void => {
  if (process.env.NODE_ENV === 'development') {
    console.log("Beauty Profiler Results:");
    console.log("- Allure:", results.allure.label);
    console.log("- Main fetiche fragrance:", results.mainFeticheFragrance.label);
    console.log("- Secondary fetiche fragrance:", results.secondaryFeticheFragrance.label);
    console.log("- Top loubiworld fragrance:", results.topLoubiworldFragrance.label);
    console.log("- Top glamliner:", results.topGlamliner.label);
    console.log("- Top other products:", results.topOtherProducts.map(p => p.label));
  }
};


